import script from "./TheRadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRadioButton.vue?vue&type=script&setup=true&lang=js"

import "./TheRadioButton.vue?vue&type=style&index=0&id=cf8f9896&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf8f9896"]])

export default __exports__